<div class="loader-container" *ngIf="isLoading">
    <div class="loader"></div>
</div>
  